export function n(v) {
  const x = Number(v || 0);
  return Number.isFinite(x) ? x.toLocaleString("en-IN") : v || "-";
}

export function money(v) {
  return `₹${n(v)}`;
}

export function dt(v) {
  return v ? new Date(v).toLocaleString("en-IN", { dateStyle: "short", timeStyle: "short" }) : "-";
}

export function shortDate(v) {
  if (!v) return "-";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
}

export const th = "px-4 py-3 text-left text-[11px] font-black capitalize tracking-wide text-[#d86a78]";
export const td = "px-4 py-3 text-xs font-semibold text-slate-600";
